import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import LoadingSpin from "../../loadingSpin/LoadingSpin";
import {
  Card,
  Col,
  Divider,
  Form,
  Input,
  notification,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

import GetBinService from "../../../services/Wash-service/GetBinService";
import garment_img from "../../../assets/dashboard/garment_img.png";
import ResponseMessage from "../../Comman/Notification/ResponseMessge";
import "../../../styles/global-ui.css";

const { Title, Text } = Typography;

const ViewBinData = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();

  const [binId, setBinId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [displayGarment, setDisplayGarment] = useState([]);

  const openNotification = (type, title, description) => {
    api[type]({ message: title, description });
  };

  useEffect(() => {
    const fetchData = async () => {
      const queryParams = new URLSearchParams(location.search);
      const id = queryParams.get("binId");

      setBinId(id);

      if (!id) {
        ResponseMessage.error("No Bin ID provided.");
        return;
      }

      setIsLoading(true);
      try {
        const response = await GetBinService.ViewBinbyId(id);

        if (Array.isArray(response?.data) && response.data.length > 0) {
          setDisplayGarment(response.data);
        } else {
          openNotification("warning", "No Data", "No Bin data found");
        
        }
      } catch (error) {
        console.error(error);
        openNotification("error", "Error", "Failed to fetch data");
      
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [location]);

  const aggregatedSizes = displayGarment.reduce((acc, garment) => {
    const sizeData = JSON.parse(garment.size_qty);
    Object.keys(sizeData).forEach((size) => {
      const qty = Number(sizeData[size]);
      if (qty > 0) {
        acc[size] = (acc[size] || 0) + qty;
      }
    });
    return acc;
  }, {});

  const totalQuantity = Object.values(aggregatedSizes).reduce(
    (sum, qty) => sum + qty,
    0
  );

  // const handleBack = () => {
  //   navigate("/dashboard");
  // };

  const formText = {
    color: "black",
    fontWeight: "bold",
  };

  return (
    <div className="page-container">
      {contextHolder}

      {isLoading && (
        <div className="dashboard-overlay-loader">
          <LoadingSpin />
        </div>
      )}

      {/* ================= HEADER ================= */}
      <div className="page-header">
        <div className="page-title-wrap">
          <Title level={3} className="page-title">
            <ArrowLeftOutlined
              
              style={{ marginRight: 10, cursor: "pointer" }}
            />
            Bin {binId}
          </Title>
          <Text className="page-subtitle">
            Detailed view of garments inside the selected bin
          </Text>
        </div>
      </div>

      <Divider className="page-divider" />

      {/* ================= STATS ================= */}
      <div className="compact-stats" style={{ marginBottom: 20 }}>
        <Row gutter={[16, 8]} justify="center">
          <Col xs={12} sm={8}>
            <div className="compact-stat-item">
              <div className="compact-stat-value">{totalQuantity}</div>
              <div className="compact-stat-label">Total Quantity</div>
            </div>
          </Col>

          {Object.entries(aggregatedSizes).map(([size, qty]) => (
            <Col xs={12} sm={4} key={size}>
              <div className="compact-stat-item">
                <div className="compact-stat-value">{qty}</div>
                <div className="compact-stat-label">{size}</div>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      {/* ================= CARDS ================= */}
      <Row gutter={[16, 16]}>
        {displayGarment.length > 0 ? (
          displayGarment.map((garment) => {
            const sizeData = JSON.parse(garment.size_qty);

            const filteredSizeData = Object.keys(sizeData)
              .filter((size) => Number(sizeData[size]) > 0)
              .reduce((acc, size) => {
                acc[size] = sizeData[size];
                return acc;
              }, {});

            const sizeColumns = Object.keys(filteredSizeData).map((size) => ({
              title: size,
              dataIndex: size,
              key: size,
              render: (text) => <strong>{text}</strong>,
            }));

            return (
              <Col xs={24} sm={12} lg={8} key={garment.dbd_id}>
                <Card
                  className="modern-card"
                  size="small"
                  title={
                    <>
                      Kanban No:{" "}
                      <span style={formText}>{garment.kanban_no}</span>
                    </>
                  }
                >
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={garment_img}
                      alt="Garment"
                      style={{ width: "40%" }}
                    />
                  </div>

                  <Space direction="vertical" size="small" style={{ width: "100%" }}>
                    <Form.Item label="Item No">
                      <Input value={garment.item_no} disabled style={formText} />
                    </Form.Item>

                    <Form.Item label="PO No">
                      <Input value={garment.po_no} disabled style={formText} />
                    </Form.Item>

                    <Form.Item label="Country">
                      <Input value={garment.country || "No Data"} disabled style={formText} />
                    </Form.Item>

                    <Form.Item label="Total Qty">
                      <Input value={garment.total_qty} disabled style={formText} />
                    </Form.Item>

                    <Form.Item label="Color">
                      <Input value={garment.color} disabled style={formText} />
                    </Form.Item>
                  </Space>

                  <Table
                    size="small"
                    columns={sizeColumns}
                    dataSource={[filteredSizeData]}
                    pagination={false}
                    bordered
                  />
                </Card>
              </Col>
            );
          })
        ) : (
          <Col span={24}>
            <Card className="modern-card">
              <div style={{ textAlign: "center", color: "#64748b" }}>
                No data found
              </div>
            </Card>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default ViewBinData;